import { HASH_ROUTER_PATH_SET } from "./constants/hashRouterPaths";

/**
 * HashRouter: OAuth and email flows return to path-style URLs (e.g. /auth/callback?code=...).
 * If we only rewrite in a React effect, the first paint matches "/" and users see the wrong page.
 * Run this synchronously before createRoot so HashRouter sees #/... on first match.
 */
export function bootstrapHashRouterFromPathname(): void {
  if (typeof window === "undefined") {
    return;
  }
  const { pathname, search, hash } = window.location;
  if (hash) {
    return;
  }
  if (!HASH_ROUTER_PATH_SET.has(pathname)) {
    return;
  }
  // Must use absolute URL (origin + /#/...). A relative "#..." resolves against the
  // current path and produces /auth/callback?code=...#/auth/callback?code=... (broken).
  window.history.replaceState(null, "", `${window.location.origin}/#${pathname}${search}`);
}
